import { Box, Button, Container, Typography } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { fetchEnrolledCoursesIds } from "../../redux/Actions/enrolledStudentCoursesActions";
import CoursesTile from "../CoursesTile/CoursesTile";
import Meta from "../Meta/Meta";

const GermanLanguagePage = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  const dispatch = useDispatch();
  const location = useLocation();
  const isLoggedIn = useSelector((state) => state.auth.isAuthenticated);
  const roleName = useSelector((state) => state.auth.user.roleName);

  useEffect(() => {
    if (location.hash === "#courses-section") {
      setTimeout(() => {
        document
          .getElementById("courses-section")
          ?.scrollIntoView({ behavior: "auto", block: "start" });
      }, 0);
      return;
    }
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.hash]);

  useEffect(() => {
    if (isLoggedIn && roleName === "Student") {
      dispatch(fetchEnrolledCoursesIds());
    }
  }, [dispatch, isLoggedIn, roleName]);

  return (
    <>
      <Meta
        title="ALGermanist - German Language Courses"
        description="Browse German language courses from A1 to C1, plus conversation and grammar courses with Arabic-speaking support."
        keywords="German language courses, A1, A2, B1, B2, C1, Konversationskurs, Grammatikkurs"
      />
      <Box
        sx={{
          background:
            'linear-gradient(180deg, rgba(0,0,0,.55), rgba(0,0,0,.55)), url("/service-german-language.png") center/cover no-repeat',
          color: "#fff",
          py: { xs: 8, md: 14 },
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ maxWidth: 760, textAlign: isArabic ? "right" : "left" }}>
            <Typography variant="h3" fontWeight={800} sx={{ mb: 3, lineHeight: 1.05 }}>
              {t("services.language.title")}
            </Typography>
            <Typography variant="h6" sx={{ opacity: 0.95, mb: 4, whiteSpace: "pre-line" }}>
              {t("services.language.description")}
            </Typography>
            <Button
              variant="contained"
              onClick={() => document.getElementById("courses-section")?.scrollIntoView({ behavior: "smooth" })}
              sx={{
                bgcolor: "#FFD600",
                color: "#111",
                borderRadius: 4,
                px: 4,
                py: 1.5,
                fontWeight: 700,
                textTransform: "none",
                boxShadow: "none",
                "&:hover": { bgcolor: "#e5c400" },
              }}
            >
              {t("services.language.button")}
            </Button>
          </Box>
        </Container>
      </Box>
      <CoursesTile />
    </>
  );
};

export default GermanLanguagePage;
